import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ChevronLeft } from 'lucide-react';

export const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <button 
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 mb-8 text-gray-300 hover:text-white transition-colors"
        >
            <ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-widest">Back</span>
        </button>
        
        <div className="bg-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12">
            <SectionHeader subtitle="Legal" title="Terms and Conditions" />

            <div className="prose prose-invert max-w-none prose-p:text-slate-300 prose-headings:text-white prose-a:text-astral-purple">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                
                <h2>1. Introduction</h2>
                <p>
                    Welcome to AstralVibe. These Terms and Conditions govern your use of our website located at astralvibe.art and form a binding contractual agreement between you, the user of the Site, and us.
                </p>
                
                <h2>2. Intellectual Property</h2>
                <p>
                    All content on this website, including text, graphics, logos, icons, music, and images, is the property of AstralVibe or its content suppliers and protected by international copyright laws. Unauthorized use of any material on this site is strictly prohibited.
                </p>
                
                <h2>3. Use of the Site</h2>
                <p>
                    You agree to use this site only for lawful purposes. You are prohibited from posting on or transmitting through the Site any unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, sexually explicit, profane, hateful, fraudulent, racially, ethnically, or otherwise objectionable material of any kind.
                </p>
                
                <h2>4. Demo Submissions</h2>
                <p>
                    By submitting your musical works ("Demos") to us, you acknowledge and agree that you are granting AstralVibe a non-exclusive, worldwide, royalty-free license to listen to, review, and evaluate your Demo for the sole purpose of considering it for release. This does not grant us any rights to release, distribute, or otherwise exploit your Demo without a separate, formal written agreement between you and AstralVibe. You warrant that you own all rights to the Demos you submit.
                </p>

                <h2>5. Limitation of Liability</h2>
                <p>
                    AstralVibe will not be liable for any direct, indirect, incidental, special, or consequential damages that result from the use of, or the inability to use, this site, including its materials, products, or services.
                </p>

                <h2>6. Changes to Terms</h2>
                <p>
                    We reserve the right to change these Terms and Conditions at any time. Any changes will be effective immediately upon posting on the Site. Your continued use of the Site following the posting of changes will constitute your acceptance of such changes.
                </p>

                <h2>7. Governing Law</h2>
                <p>
                    These Terms and Conditions are governed by the laws of Italy, without regard to its conflict of law principles.
                </p>
                
                <h2>Contact Us</h2>
                <p>
                    If you have any questions about these Terms, please <Link to="/contact" className="text-astral-purple hover:underline">contact us</Link>.
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};